module.exports = "<div id=\"chartContainer\" style=\"width: 100%; height: 1000px;\"></div>"